import { render, staticRenderFns } from "./MlbNewsComponent.vue?vue&type=template&id=4e01a0ed"
import script from "./MlbNewsComponent.vue?vue&type=script&lang=js"
export * from "./MlbNewsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports